<template>
       <div class="rightWrap">
          <h4>课程相关</h4>
          <md-content class="md-scrollbar">
          <ul>
            <li v-for="(item, index) in courseRelated" :key="index">
              <img :src="item.img" alt="" />
              <div>
                <p>{{ item.courseName }}</p>
                <p>{{ item.school }}</p>
                <p>{{ item.study }}</p>
              </div>
            </li>
          </ul>
         </md-content> 
        </div>
</template>
  <script>
import { getdetailList, queryCourseThree, resetSimulation } from '@/api/simulation';
import { mapGetters } from 'vuex';
import 'video.js/dist/video-js.css';
// import { Modal } from '../../../components/index';
//  import { openUriWithTimeoutHack } from "./monitoringApp";
import Swiper from 'swiper';
import moment from 'moment';
// import { openUriWithTimeoutHack } from './monitoringApp.js';
// import courseDetail from '../SimClassComponents/courseDetailWrap.vue';
import { getossUploadToken } from '@/api/user';
import Oss from 'ali-oss';
import { forEach } from 'jszip';
export default {
  props: {
    routeData:{
       type:Object,
       default:null
    }
  },
  components: {
    // Modal,
    // courseDetail,
  },
  watch: {
    routeData: {
      handler(news) {
        if (news) {
       
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage', 'course']),

    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
    //   routeData: {},
      courseRelated: [
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
   
      ],
  
    };
  },
  methods: {

    submit(){
      this.$emit('submit')
    },

    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
 
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    getRoute() {
      // courseView //查看    courseEdit 编辑
      let route = null;
      if (this.$route.query && this.$route.query.courseType) {
        route = this.$route.query.courseType;
      }
      return route;
    },
 


  },

  mounted() {
   
  },

  destroyed() {},
  created() {
    this.getRoute();
  
  },
};
</script>
  
  

  <style  lang="scss" scoped>
 .md-content {

    max-height: 530px;
    overflow: auto;
  }
.rightWrap {
  width:38.5%;
  float: right;
  height: auto;
  padding: 20px 6px;
  background: #fff;
  // border-left: 1px solid #cacaca;
}
.rightWrap h4 {
  font-weight: bold;
  margin-bottom: 20px;
  color: #5e5e5e;
}
ul {
  padding: 0;
  margin: 0;
}
ul > li {
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
ul > li img {
  width: 140px;
  height: 100px;
  margin-right: 10px;
  cursor: pointer;
}
ul > li p {
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  margin: 0px;
  cursor: pointer;
}
ul > li p:first-child {
  font-weight: bold;
}
.itemWrap h5 {
  font-weight: bold;
}
.threeText {
  margin-left: 90px;
  margin-bottom: 8px;
}


@media (max-width:950px) {
  .rightWrap{
    width: 100% !important;
    height: 650px;
    float: none;
    overflow: hidden;
  }
  ul > li{
    display: block;
    img{
      width: 38%;
      float: left;
    }
    div{
      width: 58%;
      float: left;
    }
  }
  /* .wrap .lbox{
    width: 100% !important;
    margin-bottom: 20px;
  }
  // .wrap .rbox{
  //   width: 100% !important;
  //   float: none !important;
  // } */
  
}
</style>